import React from "react";
import Particles from "react-tsparticles";

function Particle() {
  return (
    <Particles
      id="tsparticles"
      options={{
        // background: {
        //   color: {
        //     // value: "#0b0c1e", // Dark night sky
        //   },
        // },
        particles: {
          number: {
            value: 80,
            density: {
              enable: true,
              area: 1000,
            },
          },
          color: {
            value: "#ffffffff",
          },
          shape: {
            type: "star",
          },
          opacity: {
            value: 0.8,
            random: true,
            anim: {
              enable: true,
              speed: 0.5,
              opacity_min: 0.1,
              sync: false,
            },
          },
          size: {
            value: 2,
            random: true,
          },
          move: {
            enable: true,
            direction: "none",
            speed: 1,
            random: true,
            straight: false,
            outModes: "out",
          },
          twinkle: {
            particles: {
              enable: true,
              frequency: 0.05,
              opacity: .1,
            },
          },
        },
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: "repulse",
            },
            onHover: {
              enable: true,
              mode: "bubble",
            },
          },
          modes: {
            repulse: {
              distance: 100,
              duration: 0.4,
            },
            bubble: {
              distance: 150,
              size: 3,
              duration: 2,
              opacity: 1,
            },
          },
        },
        retina_detect: true,
      }}
    />
  );
}

export default Particle;
